<template>
  <div class="legends-block">
    <div class="container">
      <h3>Legends in the Making</h3>
      <h2>Who Will Rise?</h2>
      <p>Some chase fortune. Others chase destiny. <span>A few carve their names into history.</span></p>
      <div class="cards">
        <div class="card">
          <div class="content">
            <WinnersTopBlock :games-images="gamesImages"></WinnersTopBlock>
          </div>
        </div>

        <div class="card">
          <div class="content">
            <WinnersLiveBlock :games-images="gamesImages"></WinnersLiveBlock>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WinnersLiveBlock from "./WinnersLiveBlock.vue";
import WinnersTopBlock from "./WinnersTopBlock.vue";

export default {
  name: 'legends-block',
  components: {WinnersTopBlock, WinnersLiveBlock},
  props: {
    gamesImages: {},
  },
}
</script>

<style lang="less" scoped>
  .legends-block {
    padding-top: 0;
    padding-bottom: 140px;

    > .container {
      > h3 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        margin-bottom: 2px;
        background: linear-gradient(90.62deg, #DF60FF 0%, #9C94FF 49.03%, #44E9C3 62.94%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      > h2 {
        color: #FFF;
        font-family: Poppins;
        font-weight: 700;
        font-size: 50px;
        line-height: 64px;
        text-align: center;
        margin-bottom: 16px;
      }
      > p {
        color: #FFFFFF99;
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 50px;
        > span {
          color: #FFF;
          font-weight: 600;
        }
      }
      > .cards {
        display: grid;
        grid-template-columns: 2fr auto;
        grid-template-rows: max-content;
        gap: 20px;
        margin-bottom: 40px;
        > .card {
          background: #C9D8FF0F;
          border-radius: 30px;
          padding: 24px 30px;
          display: flex;
          gap: 20px;
          align-items: flex-start;
          justify-content: center;
          > .image {
            > img {
              display: block;
            }
          }
          > .content {
            width: 100%;
            > strong {
              display: block;
              color: #FFF;
              font-family: Poppins;
              font-weight: 700;
              font-size: 20px;
              line-height: 28px;
              margin-bottom: 6px;
            }
            > p {
              color: #FFFFFF99;
              font-family: Poppins;
              font-weight: 500;
              font-size: 18px;
              line-height: 28px;
            }
          }
        }
      }
      > .buttons {
        display: flex;
        gap: 10px;
        justify-content: center;
        align-items: center;
        > a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 310px;
          height: 60px;
          border-radius: 14px;
          transition: all .2s;
          color: #fff;
          font-size: 16px;
          line-height: 24px;
          border: 1px solid hsla(0, 0%, 100%, .2);
          &:hover {
            border-color: #fff;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .legends-block {
      padding-top: 0;
      padding-bottom: 150px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 30px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 36px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 40px;
        }
        > .cards {
          display: grid;
          grid-template-columns: 2fr auto;
          grid-template-rows: max-content;
          gap: 20px;
          margin-bottom: 40px;
          > .card {
            background: #C9D8FF0F;
            border-radius: 30px;
            padding: 24px 30px;
            display: flex;
            gap: 20px;
            align-items: flex-start;
            justify-content: center;
            > .image {
              > img {
                display: block;
              }
            }
            > .content {
              width: 100%;
              > strong {
                display: block;
                color: #FFF;
                font-family: Poppins;
                font-weight: 700;
                font-size: 20px;
                line-height: 28px;
                margin-bottom: 6px;
              }
              > p {
                color: #FFFFFF99;
                font-family: Poppins;
                font-weight: 500;
                font-size: 18px;
                line-height: 28px;
              }
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 310px;
            height: 60px;
            border-radius: 14px;
            transition: all .2s;
            color: #fff;
            font-size: 16px;
            line-height: 24px;
            border: 1px solid hsla(0, 0%, 100%, .2);
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .legends-block {
      padding-top: 0;
      padding-bottom: 60px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 30px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 36px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 40px;
        }
        > .cards {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 40px;
          > .card {
            background: #C9D8FF0F;
            border-radius: 30px;
            padding: 24px 30px;
            display: flex;
            gap: 20px;
            align-items: flex-start;
            justify-content: center;
            &:nth-child(1) {
              padding-bottom: 34px;
            }
            > .image {
              > img {
                display: block;
              }
            }
            > .content {
              width: 100%;
              > strong {
                display: block;
                color: #FFF;
                font-family: Poppins;
                font-weight: 700;
                font-size: 20px;
                line-height: 28px;
                margin-bottom: 6px;
              }
              > p {
                color: #FFFFFF99;
                font-family: Poppins;
                font-weight: 500;
                font-size: 18px;
                line-height: 28px;
              }
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 310px;
            height: 60px;
            border-radius: 14px;
            transition: all .2s;
            color: #fff;
            font-size: 16px;
            line-height: 24px;
            border: 1px solid hsla(0, 0%, 100%, .2);
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .legends-block {
      padding-top: 0;
      padding-bottom: 20px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 30px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 36px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 40px;
        }
        > .cards {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 40px;
          margin-left: -15px;
          width: calc(100% + 30px);
          > .card {
            background: #C9D8FF0F;
            border-radius: 0;
            padding: 24px 30px;
            display: flex;
            gap: 20px;
            align-items: flex-start;
            justify-content: center;
            &:nth-child(1) {
              padding-bottom: 34px;
            }
            > .image {
              > img {
                display: block;
              }
            }
            > .content {
              width: 100%;
              > strong {
                display: block;
                color: #FFF;
                font-family: Poppins;
                font-weight: 700;
                font-size: 20px;
                line-height: 28px;
                margin-bottom: 6px;
              }
              > p {
                color: #FFFFFF99;
                font-family: Poppins;
                font-weight: 500;
                font-size: 18px;
                line-height: 28px;
              }
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 310px;
            height: 60px;
            border-radius: 14px;
            transition: all .2s;
            color: #fff;
            font-size: 16px;
            line-height: 24px;
            border: 1px solid hsla(0, 0%, 100%, .2);
            &:hover {
              border-color: #fff;
            }
          }
        }
      }
    }
  }
</style>
